import { takeEvery, call, put, all } from "redux-saga/effects";
import {
  GET_HOMEPAGE_DATA,
  GET_MENU_DATA,
  GET_CAROUSEL_DATA,
  GET_ABOUT_DATA,
  GET_CATEGOREIS,
  GET_PRODUCTS,
  GET_CONTACT_DATA,
  GET_FOOTER_DATA,
  GET_FAMILY_DATA,
  GET_SECTIONS,
  GET_CERTIFICATES,
  GET_PRODUCTION_DATA
} from "store/actionTypes";
import { Items } from "constants/adminMenu";

const { landing, menu, carousel, about, family, categories, products, footer, contact, sections, certificates, production, production_doc } = Items;

export function* GetHomepageDataWatcher() {
  yield takeEvery(GET_HOMEPAGE_DATA.WATCH, GetHomepageDataWorker);
}

function* GetHomepageDataWorker(data) {
  try {
    yield put({ type: GET_HOMEPAGE_DATA.LOAD });
    const sectionsSaga = put({ type: GET_SECTIONS.WATCH, payload: { collection: sections, document: "ids" } });
    const menuSaga = put({ type: GET_MENU_DATA.WATCH, payload: { collection: landing, document: menu } });
    const carouselSaga = put({ type: GET_CAROUSEL_DATA.WATCH, payload: { collection: carousel } });
    const aboutSaga = put({ type: GET_ABOUT_DATA.WATCH, payload: { collection: about } });
    const familySaga = put({ type: GET_FAMILY_DATA.WATCH, payload: { collection: family } });
    const categoriesSaga = put({ type: GET_CATEGOREIS.WATCH, payload: { collection: categories } });
    const productsSaga = put({ type: GET_PRODUCTS.WATCH, payload: { collection: products } });
    const contactsSaga = put({ type: GET_CONTACT_DATA.WATCH, payload: { collection: landing, document: contact } });
    const footersSaga = put({ type: GET_FOOTER_DATA.WATCH, payload: { collection: landing, document: footer } });
    const certificatesSaga = put({ type: GET_CERTIFICATES.WATCH, payload: { collection: certificates, } });
    const productionData = put({ type: GET_PRODUCTION_DATA.WATCH, payload: { collection: production, document: production_doc } });
    yield all([
      menuSaga,
      sectionsSaga,
      carouselSaga,
      aboutSaga,
      familySaga,
      categoriesSaga,
      productsSaga,
      contactsSaga,
      footersSaga,
      certificatesSaga,
      productionData,
    ]);
    yield put({ type: GET_HOMEPAGE_DATA.SUCCESS });
  } catch (e) {
    yield put({ type: GET_HOMEPAGE_DATA.FAIL, payload: e.message });
  }
}
